import React, { Component } from 'react';
import Waypoint from 'react-waypoint';

class Reveal extends Component {
  constructor() {
    super();
    this.state = {
      isInView: false,
    };
  }

  componentDidMount() {
    this.setState({
      renrender: window.location.href,
    });
  }

  onEnter = ({ previousPosition, currentPosition, event }) => {
    if (previousPosition === Waypoint.below) {
      this.setState({
        isInView: true,
      });
    }
  };

  onLeave = ({ previousPosition, currentPosition, event }) => {
    if (currentPosition === Waypoint.below) {
      this.setState({
        isInView: false,
      });
    }
  };

  render() {
    const children = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        isInView: this.state.isInView,
      });
    });

    return (
      <div key={this.props.key}>
        <Waypoint onEnter={this.onEnter} onLeave={this.onLeave} />
        {children}
      </div>
    );
  }
}

export default Reveal;



// WEBPACK FOOTER //
// ./src/components/reveal/index.js